// import ProtectedRoute from '@/components/Router/ProtectedRoute';
import { Route } from 'react-router-dom';
/**
 * 获取对应地方的路由
 * @param appRouters 所有路由配置
 * @returns 
 */
const getRouters = (appRouters: any) => {
    return (
        appRouters
            .reduce((arr: any, route: any, index: any) => {
                if (route.children && route.children.length) {
                    arr = arr.concat(getRouters(route.children));
                } else {
                    arr.push(
                        // (<ProtectedRoute key={index} path={route.path} component={route.component} permission={route.permission} />)
                        <Route
                            key={index}
                            path={route.path}
                            component={route.component}
                            exact={true}
                        />
                    )
                }
                return arr
            }, [])
    )
}
export default getRouters;